import { render, staticRenderFns } from "./PatientPeriodFormAdd.vue?vue&type=template&id=0713cc4f&scoped=true"
import script from "./PatientPeriodFormAdd.vue?vue&type=script&lang=js"
export * from "./PatientPeriodFormAdd.vue?vue&type=script&lang=js"
import style0 from "./PatientPeriodFormAdd.vue?vue&type=style&index=0&id=0713cc4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713cc4f",
  null
  
)

export default component.exports